import { toothLabel } from './toothGeometry';

interface ElasticsDrawingBannerProps {
    /** Teeth tapped so far for the in-progress band. */
    selected: number[];
    onUndoLast: () => void;
    onCancel: () => void;
}

/** Shown only while an elastic is being placed: what to tap next, with Undo/Cancel. */
export function ElasticsDrawingBanner({
    selected,
    onUndoLast,
    onCancel
}: ElasticsDrawingBannerProps) {
    return (
        <div className="flex items-center justify-between gap-3 rounded-lg border border-gray-900 bg-gray-50 px-3 py-2.5">
            <span className="text-xs text-gray-700">
                {selected.length === 0
                    ? 'Tap the teeth this elastic hooks, in order.'
                    : selected.length === 1
                      ? `Tap the next tooth. (Started at ${selected[0]}.)`
                      : `Tap the next tooth, or tap ${selected[0]} again to close the band.`}
                {selected.length > 0 && (
                    <span className="ml-1 text-gray-500">
                        ({selected.map(toothLabel).join(' → ')})
                    </span>
                )}
            </span>
            <div className="flex flex-shrink-0 items-center gap-2">
                {selected.length > 0 && (
                    <button
                        type="button"
                        onClick={onUndoLast}
                        className="text-xs font-medium text-gray-500 hover:text-gray-800"
                    >
                        Undo
                    </button>
                )}
                <button
                    type="button"
                    onClick={onCancel}
                    className="text-xs font-medium text-gray-500 hover:text-red-600"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
}
